import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "TransitionTriggersModal"
}
const _hoisted_2 = { class: "TransitionTriggersModalContentBlock" }
const _hoisted_3 = { class: "ConfirmationTextContainer" }
const _hoisted_4 = {
  key: 0,
  class: "WarningContainer"
}
const _hoisted_5 = {
  key: 1,
  class: "WarningContainer"
}
const _hoisted_6 = { class: "TransitionTriggersButtonContainer" }
const _hoisted_7 = { class: "TransitionTriggersModalHeaderBlock" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "TransitionTriggersModalContentBlock" }
const _hoisted_11 = {
  key: 0,
  class: "TriggerPayloadContainer"
}
const _hoisted_12 = { class: "TriggerPayloadForm" }
const _hoisted_13 = {
  key: 0,
  class: "ElementWrapper"
}
const _hoisted_14 = ["id", "onClick"]
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "ElementWrapper" }
const _hoisted_17 = {
  key: 0,
  class: "ChallengingBackContainer"
}
const _hoisted_18 = { class: "TextSize" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "TransitionTriggersButtonContainer" }
const _hoisted_21 = { class: "TransitionTriggersModalContentBlock" }
const _hoisted_22 = { class: "InvoiceSummaryContainer" }
const _hoisted_23 = { class: "TransitionTriggersButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceSummary = _resolveComponent("InvoiceSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modalStatusIsConfirmation)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "TransitionTriggersModalHeaderBlock" }, [
            _createElementVNode("h3", null, "Change enrolments status")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass({ ConfirmationContentWithWarning: _ctx.isTriggerRevised || _ctx.isTriggerInScopeWithIncompleteEnrolments })
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(" You are about to mark " + _toDisplayString(_ctx.selectedEnrolments ? _ctx.selectedEnrolments.length : 0) + " enrolment(s) as ", 1 /* TEXT */),
                _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.selectedTransitionTrigger ? _ctx.selectedTransitionTrigger.name : '') + "\"", 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createTextVNode(". ", -1 /* CACHED */))
              ]),
              (_ctx.isTriggerRevised)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */),
                    _createTextVNode(" You will not be able to undo this step back. Proceed with caution. ", -1 /* CACHED */)
                  ]))]))
                : (_ctx.isTriggerInScopeWithIncompleteEnrolments)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */),
                      _createTextVNode(" Some of the selected enrolments are missing activity dates. It can take up to 15 minutes for these dates to be set for recently imported enrolments. Are you sure you want to put them \"in scope\"? ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "DriverButton PrimaryButton",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTransitionConfirmed()))
              }, "Confirm"),
              _createElementVNode("button", {
                class: "ExitButton CancelButton",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTransitionCanceled()))
              }, "Cancel")
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.modalStatusIsTriggerPayload)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isTriggerConfirmationChallenged)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_8, "Revisit enrolment(s)"))
                : (_openBlock(), _createElementBlock("h3", _hoisted_9, "Change enrolments status"))
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.triggerPayload)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" You are about to mark " + _toDisplayString(_ctx.selectedEnrolments ? _ctx.selectedEnrolments.length : 0) + " enrolment(s) as ", 1 /* TEXT */),
                      _createElementVNode("strong", null, "\"" + _toDisplayString(_ctx.selectedTransitionTrigger ? _ctx.selectedTransitionTrigger.name : '') + "\"", 1 /* TEXT */),
                      _cache[11] || (_cache[11] = _createTextVNode(". ", -1 /* CACHED */))
                    ]),
                    _createElementVNode("form", _hoisted_12, [
                      (!_ctx.isTriggerConfirmationChallenged)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ReasonTitle" }, "Please specify your reason(s):", -1 /* CACHED */)),
                            _createElementVNode("ul", {
                              class: _normalizeClass(["CheckboxList", { HasError: _ctx.noDisqualificationReasonSelectedError }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disqualificationReasons, (reason) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: reason.value,
                                  class: "CheckboxListItem"
                                }, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    name: "DisqualificationReason",
                                    id: reason.value,
                                    onClick: ($event: any) => (_ctx.triggerPayload.disqualificationReasonSelection.toggle(reason))
                                  }, null, 8 /* PROPS */, _hoisted_14),
                                  _createElementVNode("label", {
                                    class: "DisqualificationReasonLabel",
                                    for: reason.value
                                  }, _toDisplayString(reason.name), 9 /* TEXT, PROPS */, _hoisted_15)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 2 /* CLASS */),
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "MessageContainer" }, [
                              _createElementVNode("span", { class: "Message ErrorMessage" }, "Please choose at least one reason")
                            ], -1 /* CACHED */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.isTriggerConfirmationChallenged)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("p", null, "Please specify the reason for revisiting the confirmation.", -1 /* CACHED */),
                              _createElementVNode("p", { class: "WarningContainer" }, [
                                _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }),
                                _createTextVNode(" The client will see this message in the tool. ")
                              ], -1 /* CACHED */)
                            ]))]))
                          : _createCommentVNode("v-if", true),
                        _withDirectives(_createElementVNode("textarea", {
                          class: _normalizeClass(["Textarea Note", { HasError: _ctx.noTriggerPayloadExplanationError }]),
                          placeholder: "Notes",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.triggerPayload.note) = $event)),
                          maxlength: "140"
                        }, null, 2 /* CLASS */), [
                          [_vModelText, _ctx.triggerPayload.note]
                        ]),
                        _createElementVNode("p", _hoisted_18, [
                          (_ctx.triggerPayload.note)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.triggerPayload.note.length), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _cache[15] || (_cache[15] = _createTextVNode("(max 140) ", -1 /* CACHED */))
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "MessageContainer" }, [
                          _createElementVNode("span", { class: "Message ErrorMessage" }, "Please specify your reason in the notes")
                        ], -1 /* CACHED */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "DriverButton PrimaryButton",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTransitionConfirmed()))
                }, "Confirm"),
                _createElementVNode("button", {
                  class: "ExitButton CancelButton",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onTransitionCanceled()))
                }, "Cancel")
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.modalStatusIsInvoiceBatch)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "TransitionTriggersModalHeaderBlock" }, [
                _createElementVNode("h3", null, "Create an invoice batch")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", null, " You are about to create an invoice batch for " + _toDisplayString(_ctx.selectedEnrolments ? _ctx.selectedEnrolments.length : 0) + " enrolment(s). Below you can find a summary of it: ", 1 /* TEXT */),
                  _createVNode(_component_InvoiceSummary),
                  _cache[17] || (_cache[17] = _createElementVNode("p", { class: "WarningContainer" }, [
                    _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }),
                    _createTextVNode(" Please note that after a batch is created, you won’t be able to move these items to a different batch, or add new items to this batch. ")
                  ], -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "DriverButton PrimaryButton",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onTransitionConfirmed()))
                  }, "Create invoice batch"),
                  _createElementVNode("button", {
                    class: "ExitButton CancelButton",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onTransitionCanceled()))
                  }, "Cancel")
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}